import React, { useEffect, useState } from 'react';

import RiskSummary from '../Charts/Department/RiskSummary';
import ActionStatus from '../Charts/Department/ActionStatus';
import TopRisks from '../Charts/Department/TopRisks';
//import TopRisks from '../Charts/General/Notifications.js';
import Matrix from '../Charts/Department/Matrix';
import ComplianceMeters from "../Meters/ComplianceMeters";

import { connect } from "react-redux";
import { compose } from "redux";

import { getComplianceDashboardData } from "../../store/actions/dashboardActions";
import { openOverlay } from "../../store/actions/riskActions";


const ComplianceDashboard = (props) => {
  const { openOverlayFN, compliance_id, compliance_dashboard_data, getComplianceDashboardDataFN, setComplianceDashboardData } = props;

  const [isRepExpanded, setIsRepExpanded] = useState(false);
  const [isFinExpanded, setIsFinExpanded] = useState(false);
  const [isOpExpanded, setIsOpExpanded] = useState(false);

  //////console.log(props);
  //////console.log('compliance_id:', compliance_id);
  useEffect(() => {
    //////console.log("Use effect triggered!");
    getComplianceDashboardDataFN(compliance_id);
  }, [compliance_id, getComplianceDashboardDataFN]);

  //////console.log('compliance_dashboard_data:', compliance_dashboard_data);

  useEffect(() => {
    //////console.log("✅ useEffect triggered on mount! compliance_id:", compliance_id);

    if (compliance_id) {
      getComplianceDashboardDataFN(compliance_id);
    }
  }, []);

  useEffect(() => {
    setComplianceDashboardData(compliance_dashboard_data);
  }, [compliance_dashboard_data, setComplianceDashboardData]);

  //////console.log(compliance_dashboard_data);


  const CardHeader = ({ title }) => (
    <div className="bg-white text-gray-900 px-4 py-2 flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">
      <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
        {title}
      </h2>
    </div>
  );

  const CardHeader2 = ({ title, onExpand }) => (
    <div className="bg-white text-gray-900 px-4 py-2 flex items-center justify-between rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-200">
      <div className="flex items-center overflow-hidden">
        <h2 className="text-base sm:text-xs md:text-xs lg:text-base m-0 whitespace-nowrap truncate">
          {title}
        </h2>
      </div>

      {onExpand && (
        <button
          onClick={onExpand}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 hover:bg-gray-50"
          title="Expand"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M3 15v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M21 9V3h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M3 21l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M21 3l-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      )}
    </div>
  );




  return (
    compliance_dashboard_data ? (
      <div className="flex min-w-0 flex-col" style={{ minHeight: `calc(100vh - 245px)` }}>

        <div className="min-w-0 flex-1">
          <ComplianceMeters compliance_id={compliance_id} />
        </div>

        {/* First Row */}
        <div className="flex flex-grow w-full">
          <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
            <CardHeader title="Compliance Summary" />
            <div className="contents">
              <RiskSummary height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.risk_summary} />
            </div>
          </div>

          <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
            <CardHeader title="Action Status" />
            <div className="contents">
              <ActionStatus height={(window.innerHeight - 550) / 2} data={compliance_dashboard_data.action_status} />
            </div>
          </div>

          <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
            <CardHeader title="Top Compliance Risks" />
            <div className="contents p-2">
              <TopRisks height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.top_5_compliance_risks} />
            </div>
          </div>
        </div>

        {/* Second Row */}
        <div className="flex flex-grow w-full mt-4">
          <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
            <CardHeader2
              title="Inherent Compliance Risk"
              onExpand={() => setIsFinExpanded(true)}
            />
            <div className="contents p-2">
              <Matrix
                height={(window.innerHeight - 450) / 2}
                data={compliance_dashboard_data.inherent_matrix}
                which="inherent"
                isExpanded={isFinExpanded}
                openExpanded={() => setIsFinExpanded(true)}
                closeExpanded={() => setIsFinExpanded(false)}
                openOverlayFN={openOverlayFN}
              />
            </div>
          </div>

          <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
            <CardHeader2
              title="Residual Compliance Risk"
              onExpand={() => setIsRepExpanded(true)}
            />
            <div className="contents p-2">
              <Matrix
                height={(window.innerHeight - 450) / 2}
                data={compliance_dashboard_data.residual_matrix}
                which="residual"
                isExpanded={isRepExpanded}
                openExpanded={() => setIsRepExpanded(true)}
                closeExpanded={() => setIsRepExpanded(false)}
                openOverlayFN={openOverlayFN}
              />
            </div>
          </div>

          <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
            <CardHeader2
              title="Future Compliance Risk"
              onExpand={() => setIsOpExpanded(true)}
            />
            <div className="contents p-2">
              <Matrix
                height={(window.innerHeight - 450) / 2}
                data={compliance_dashboard_data.future_matrix}
                which="future"
                isExpanded={isOpExpanded}
                openExpanded={() => setIsOpExpanded(true)}
                closeExpanded={() => setIsOpExpanded(false)}
                openOverlayFN={openOverlayFN}
              />
            </div>
          </div>
        </div>

      </div>
    ) : (
      <div>Loading Compliance Dashboard...</div>
    ));
};

const mapStateToProps = (state) => {
  //console.log("Redux state:", state.dashboard.compliance_dashboard_data);
  return {
    compliance_dashboard_data: state.dashboard.compliance_dashboard_data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getComplianceDashboardDataFN: (compliance_id) => dispatch(getComplianceDashboardData(compliance_id)),
    openOverlayFN: (id) => dispatch(openOverlay(id)),
  };
};



export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceDashboard);